module.exports = __webpack_public_path__ + "assets/img/bgPoster_graduate.b9c51e2f.jpg";